import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Button, Modal, Animation, TextField, CheckGraphic } from 'components'
import { FaTimes } from 'react-icons/fa'
import { AnimateSharedLayout, motion } from 'framer-motion';
import BannerImg from 'resources/feedback-banner.png'

import { Feedback } from 'schema'
import * as actionCreators from 'store/actions'
import * as api from 'api'

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    secondaryColor: 'var(--secondary-color)'
}

const Container = styled.div`
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.styles.backgroundColor};
    width: 30rem;
    height: 40rem;
    @media (max-width: 600px) {
        width: 25rem;
        height: 30rem;
    }
`

const InlineContainer = styled.div`
    padding: 0.25rem 0.25rem 1rem 0.25rem;
`

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Body = styled.div`
    height: 100%;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: ${props => props.inline ? 'auto 10rem auto' : !props.submitted ? '40% max-content 1fr 2rem' : '40% max-content 1fr'};
    grid-gap: 0.5rem;
    overflow: hidden;
`

const InputContainer = styled.div`
    background-color: ${props => props.styles.secondaryColor};
    padding: 0.5rem;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: ${props => `2px solid ${props.error ? 'var(--error-color)' : 'transparent'}`};
`

const Subtitle = styled.div`
    font-weight: bold;
    font-size: 0.9rem;
    opacity: 90%;
    /* color: var(--secondary-accent-color); */
`

const Error = styled.div`
    font-size: 0.9rem;
    color: var(--error-color);
    transform: translateY(-0.2rem);
    /* margin-top: 0.2rem; */
    /* :before {
        content: '*'
    } */
`

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
`

class FeedbackModal extends Component {
    constructor(props){
        super(props);
        this.buttonStyle = {
            backgroundColor: 'var(--focus-color)',
            width: 'min-content',
            margin: 0
        }
        this.state = {
            value: null,
            submitted: false,
            error: null
        }
        this.updatedStyle = Object.assign({}, defaultStyle, this.props.styles)
    }

    onEdit = (event) => {
        const value = event.target.value
        if(event.keyCode === 13){
            // this.onSubmit()
        } else {
            this.setState({ value: value, error: value.length > 0 && null })
        }
    }

    onSubmit = async () => {
        if(!this.state.value || this.state.length === 0){
            this.setState({ error: "*Field can't be empty" })
        } else if(!this.state.value || this.state.value.length > 0){
            const fb = new Feedback({ userID: this.props.uid, value: this.state.value })
            await api.createFeedback(fb)
            .then(response => {
                console.log('[Feedback response]', response)
                if(response['data']['success']){
                    this.setState({ submitted: true, error: null })
                } else {
                    const errorMsg = response['data']['error'] === 'Too many submissions' ? "*You've exceeded the quota today, try again tomorrow" : '*Something went wrong'
                    this.setState({ submitted: false, error: errorMsg })
                } 
            })
            .catch (err => {
                console.log(err)
                this.setState({ submitted: false, error: '*Something went wrong' })
            })
        }
    }

    getFeedbackHandler = async () => {
        await api.getFeedbacks({"filters": {userID: this.props.uid}})
        .then(response => {
            console.log('[Feedback success]',response)
        })
        .catch(err => {
            console.log('[Feedback error]', err)
        })
    }

    render() {
        if(this.props.inline){
            return (
                <InlineContainer>
                    <Body submitted={this.state.submitted} inline>
                        <div style={{padding: '0 0.25rem', fontSize: '0.9rem'}}>Hi 👋 If you've encountered a bug or have a feature that you would like developed, let us know!</div>

                        <InputContainer error={this.state.error} styles={this.updatedStyle}>
                            {!this.state.submitted ?
                            <TextField value={this.state.value} placeholder={'Tell us more...'} rowsMax={99}
                                onKeyDown={this.onEdit} onKeyPress={this.onEdit} onChange={this.onEdit}/>
                            : <CheckGraphic styles={{color: 'var(--focus-color)', size: '40'}}/>}
                            {this.state.submitted && 
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.5, delay: 0.5 }}>
                                <Subtitle>Got it, thanks!</Subtitle>
                            </motion.div>}
                        </InputContainer>
                        
                        <Wrapper>
                            <Error>{this.state.error}</Error>
                            {/* <Button text='Get' onSelect={this.getFeedbackHandler}/> */}
                            {!this.state.submitted && <Button styles={this.buttonStyle} text='Submit' onSelect={this.onSubmit}/>}
                        </Wrapper>
                    </Body>
                </InlineContainer>
            )
        } else {
            return (
                <Modal>
                    <Container styles={this.updatedStyle}>
                        <Header>
                            <div style={{fontWeight: 'bold', fontSize: '0.9rem'}}>Feedback</div>
                            <Button icon={<FaTimes/>} onSelect={() => {this.props.setModal(null,null)}} tooltip='Close' styles={{backgroundColor:'var(--primary-color)', boxShadowColor: 'transparent', padding:'0.3rem', margin: 0}}/>
                        </Header>
                        <Body submitted={this.state.submitted}>
                            <img src={BannerImg} style={{width:'100%', height:'100%',objectFit:'contain'}}/>
                            {/* <Animation animation='expand'>
                                <img src={BannerImg} style={{width:'100%', height:'100%',objectFit:'contain'}}/>
                            </Animation> */}
                            <div style={{padding: '0 0.25rem', fontSize: '0.9rem'}}>Hi 👋 If you've encountered a bug or have a feature that you would like developed, let us know!</div>
    
                            <AnimateSharedLayout>
                                <motion.div layout>
                                    <InputContainer error={this.state.error} styles={this.updatedStyle}>
                                        {!this.state.submitted ?
                                        <TextField value={this.state.value} placeholder={'Tell me more...'} rowsMax={99}
                                            onKeyDown={this.onEdit} onKeyPress={this.onEdit} onChange={this.onEdit}/>
                                        : <CheckGraphic styles={{color: 'var(--focus-color)', size: '40'}}/>}
                                        {this.state.submitted && 
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ duration: 0.5, delay: 0.5 }}>
                                            <Subtitle>Got it, thanks!</Subtitle>
                                        </motion.div>}
                                    </InputContainer>
                                </motion.div>
                                
                                <Wrapper>
                                    <Error>{this.state.error}</Error>
                                    {/* <Button text='Get' onSelect={this.getFeedbackHandler}/> */}
                                    {!this.state.submitted && <Button styles={this.buttonStyle} text='Submit' onSelect={this.onSubmit}/>}
                                </Wrapper>
                            </AnimateSharedLayout>
                        </Body>
                        
                    </Container>
                </Modal>
                
            )
        }
        
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        inputID: state.content.inputID,
        modalID: state.content.modalID,
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        updateUser: (user) => dispatch(actionCreators.updateUser(user)),
        updateItem: (item, data) => dispatch(actionCreators.updateItem(item, data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackModal);
